import { render, staticRenderFns } from "./replyContent.vue?vue&type=template&id=e20b663e&"
import script from "./replyContent.vue?vue&type=script&lang=js&"
export * from "./replyContent.vue?vue&type=script&lang=js&"
import style0 from "./replyContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports